module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "page_8"
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "cn"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Materials")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Let’s get started. With everything that you do, remember that it is the experimenting that really matters. Try not to think about ‘creating a masterpiece’ or ‘spoiling your work’ by making changes. The worst that can happen is that it will go in the bin. My bin is always very full! We are all learning, and we only improve by practising, trying new things and taking risks.")]), _vm._v(" "), _c('h3', {
    staticClass: "h3"
  }, [_c('img', {
    staticClass: "v1",
    attrs: {
      "alt": "Image",
      "src": "images/sqb1.jpg"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("What are pastels?")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Artists’ quality pastels are dry sticks of colour that you hold in your hand. They are called soft pastels, in order to distinguish them from oil pastels, which are an entirely separate medium. Soft pastels are a blend of two main constituents: pigment, which varies in quality, lightfastness and strength from brand to brand; and binder, which holds the pigment together in a form that can be held and manipulated. They are bought as sticks or smaller half sticks.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Despite the name, soft pastels vary from being soft to quite hard, depending on the proportion of pigment to binder, and the quality of pigment used. Artists like to have different grades of softness to work with, ranging from creamier pastels to firmer Conté crayons and pastel pencils.")]), _vm._v(" "), _c('div', {
    staticClass: "clear"
  }), _vm._v(" "), _c('div', {
    staticClass: "ft30"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f008-01a.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Soft pastels")]), _vm._v(" Professional and artists’ quality soft pastels are made with premium quality pigments mixed with a small amount of binder. This gives them a soft, almost creamy texture when applied. Much of the work in this book is done with Unison soft pastels, although many other brands would work for all of the projects. There are many other high-quality soft pastel brands, including Sennelier, Schmincke, Terry Ludwig and Jackson’s.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Some soft pastels have more binder in the mix than really soft ones, making them feel firmer. I refer to them as ‘medium-soft’ pastels, to distinguish them from the really soft brands. I use Rembrandt, Winsor & Newton and SAA pastels as my artists’ quality medium-soft pastels. They have a good range of colours, and many artists enjoy the sharp marks they can make with them.")]), _vm._v(" "), _c('div', {
    staticClass: "clear"
  }), _vm._v(" "), _c('div', {
    staticClass: "ft30"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f008-01b.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Hard pastels")]), _vm._v(" Containing a higher proportion of binder to pigment in the mix, these pastels are harder and waxier than soft pastels, which makes them very useful for drawing and creating sharp edges. They also produce less dust. I use Conté Carrés sketching crayons – abbreviated to Conté crayons – as my preferred hard pastels. They are narrow sticks, square in section, and are made with a different type of binder to soft pastels and baked as part of the production process. They are much harder than my Unison pastels, but still artists’ quality. Conté crayons are not to be confused with Conté pastels, or Conté pastel pencils.")]), _vm._v(" "), _c('div', {
    staticClass: "clear"
  }), _vm._v(" "), _c('div', {
    staticClass: "ft30"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f008-01c.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Pastel pencils")]), _vm._v(" Encased in wood, like a graphite pencil, pastel pencils can be useful for very gentle sketches, subtle work and fine textures. In order for the colour to be strong enough to withstand sharpening, they have a high proportion of binder. I like to use Faber-Castell Pitt Pastel Pencils, as they are strong enough in terms of pigment to lay over soft, rich pastels. Conté pastel pencils are another good brand to use as they are hard but not scratchy.")]), _vm._v(" "), _c('p', {
    staticClass: "ahead"
  }, [_vm._v("Quality")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Pastel ranges are available in students’ and artists’ quality. As a general rule, you get what you pay for with your materials. Students’ quality pastels are cheaper than artists’ quality, but tend to have a high proportion of binder in the mix and be made of lower-quality pigment, so will not be lightfast.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("You will also find that with cheaper pastels you do not get a good range of very light and very dark tones, so your work may lack depth. I recommend using artists’ quality pastels to start with if you can.")]), _vm._v(" "), _c('p', {
    staticClass: "ahead"
  }, [_vm._v("Lightfastness")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("A good quality artists’ pastel will be lightfast, so will not fade in normal light conditions. With that said, no original artwork should be placed in direct sunlight. If hung away from sunlight, the colours of artists’ quality pastels will last for years and years. Cheaper art materials may not be lightfast, and you run the risk of your work fading over time.")]), _vm._v(" "), _c('p', {
    staticClass: "ahead"
  }, [_vm._v("Starting out?")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("See "), _c('span', {
    attrs: {
      "href": "#/xhtml/09_Chapter03#page_14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("page 14")]), _vm._v(" for my suggestions for a closer look at the pastel colours I recommend.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f008-01.jpg"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_9"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f009-01.jpg"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_10"
    }
  }), _vm._v(" "), _c('h3', {
    staticClass: "h3"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/sqo.jpg"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Papers and surfaces")])]), _vm._v(" "), _c('p', {
    staticClass: "ahead"
  }, [_vm._v("Pastel paper")]), _vm._v(" "), _c('div', {
    staticClass: "ft25"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f010-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Pastel paper is the easiest surface to start with. Made for pastel work, it is strong and has a texture that can hold several layers of pastel. If you want your work to last, use an artists’ quality acid-free paper. For the exercises and projects in this book, I use "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Winsor Universal Paper")]), _vm._v(" (A), and "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Canson Mi-Tientes")]), _vm._v(" (B). The latter is available in sixty colours ranging from whites, creams and subtle neutrals, to vibrant bright colours, darks and black. Like many pastel papers, both sides are textured, but one more than the other. Smooth papers can be tempting, but you won’t be able to build up many layers of pastel, and a really smooth paper will result in the pastel skidding across the surface.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("When you buy paper in pads, the more textured side is usually front side up. As this texture can be a little bit grid-like, it is a good idea to turn the pad over, and treat the back as if it is the front. This may seem a bit odd, but this grid-like texture does not always lend itself to natural subjects, especially people and animals. If you buy your paper by the sheet, you then have a choice of what size to work. It is easy to fold and tear in half if you want smaller pieces. It is usually good to go bigger with pastels as it is a loose medium, and working small makes life harder than it needs to be. I only buy paper in pads when I am travelling.")]), _vm._v(" "), _c('p', {
    staticClass: "ahead"
  }, [_vm._v("Other textured surfaces")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("When you have some experience working on paper, there are lots of textured surfaces to choose from, all suited to particular ways of working. Many experienced pastel artists make their own ground, using a combination of paints, primers, grit, pumice and other products.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Velour")]), _vm._v(" (C) This velvety surface is extremely good for soft and subtle animal work, but it can be difficult to erase marks.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Pastelmat")]), _vm._v(" (D) This surface appears quite smooth; but don’t be fooled, it can hold many layers of pigment. It is excellent for detailed work, and people who draw and paint with confidence. However, it can be difficult to move pastel around the surface and to rub out from it.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Sand papers")]), _vm._v(" (E) Sand papers like Sennelier’s sand card are very heavily textured. As a result, all the little bits of pigment sit in the tiny gaps and reflect in on each other, producing intensified colour. They are harsh if you rub in a lot with your fingers, and it is difficult to erase marks.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Primers")]), _vm._v(" (F) Colourfix primers produced by Art Spectrum are like ordinary acrylic primers but with grit or pumice added. You can buy pots of different colours to paint on yourself, or buy card ready-primed. This is a versatile textured surface that is fantastic for more experienced pastel users.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Canson touch")]), _vm._v(" (G) This lovely and versatile surface has more texture than a paper, is less harsh than sand papers, and comes in pads as well as sheets.")]), _vm._v(" "), _c('div', {
    staticClass: "tip"
  }, [_c('p', {
    staticClass: "tip-t"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Tip")])]), _vm._v(" "), _c('p', {
    staticClass: "tip-p"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("You can usually buy individual sheets of the textured surfaces listed, so try them out before you commit. We are all different, and some of them will appeal to you; others just won’t feel right.")])])])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_11"
    }
  }), _vm._v(" "), _c('h3', {
    staticClass: "h3"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/sqo.jpg"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Other tools and equipment")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Drawing board")]), _vm._v(" (A) Use a rigid surface to support your work. Drawing boards can be bought from art suppliers in several sizes, or you can have them cut to size from 6mm (¼in) MDF or hardboard at your local DIY supplier. A good size is 61 × 45cm (24 × 17¾in), which will hold a sheet of A2 paper –59 × 42cm (23½ × 16½in). I have a selection of sizes, and also lightweight versions for working outside.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Masking tape or clips")]), _vm._v(" (B) These are used to secure your surface to your drawing board.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Scraper or flat metal blade")]), _vm._v(" (C) Used to remove excess pastel from the surface, you can make a scraper yourself from thin plastic or card. To prevent scratching your work with the scraper you make, be sure to use a craft knife and a metal ruler to cut the straight edge. A blade can be used in the same way, but you need to store it safely, and be careful when travelling.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Scalpel or sharp art knife")]), _vm._v(" (D) The perfect tool for sharpening pastel pencils, or cutting small bits of eraser. These are only effective when sharp, so be prepared to replace the blade regularly.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Dry kitchen paper or tissue")]), _vm._v(" (E) Use this for cleaning your pastels.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Wet wipes or a wet cloth")]), _vm._v(" (F) Keeping your hands clean will help to keep your pastels clean. Do not clean the pastels themselves with a wet cloth – it seals the outer surface, making them difficult to use.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f011-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "ahead"
  }, [_vm._v("Optional extras")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Fixative")]), _vm._v(" (A) Fixative can affect your colours and tonal balance. Because of this, many pastel artists do not fix their work. If you choose to do so, test the fixative first.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Mountcard, primer and household brush")]), _vm._v(" (B) Quick-drying acrylic primers that create a textured surface (or tooth) are available. Use a large household brush to paint the primers onto a smooth surface such as mountcard, then leave to dry. They are then ready to work over with pastels. You can use a single colour of primer, or mix them like paints.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Brush")]), _vm._v(" (C) A watercolour brush can be used to soften areas of pastel work. Some artists also use them to rub out areas that they want to work over.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Blender")]), _vm._v(" (D) A tool for blending small areas and sharpening details. Be warned that these can encourage you to focus on detail, and forget how enjoyable and effective it can be to work loosely.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Torchon")]), _vm._v(" (E) Made of tightly rolled paper, these tools can be used for blending small areas, although many people prefer to use their fingers.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f012-01.jpg"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-058b6a56","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/08_Chapter02.vue
// module id = 84
// module chunks = 0